// elections
export const PUT_ELECTIONS = 'PUT_ELECTIONS'

// geojson
export const PUT_CDS = 'PUT_CDS'
// export const PUT_DMAS_BY_CD = 'PUT_DMAS_BY_CD'
// export const PUT_DMAS_BY_STATE = 'PUT_DMAS_BY_STATE'
export const PUT_STATES = 'PUT_STATES'

// ux
export const ADD_CANCEL_TOKEN = 'ADD_CANCEL_TOKEN'
export const CLEAR_CANCEL_TOKENS = 'CLEAR_CANCEL_TOKENS'
export const SET_SCREEN_WIDTH = 'SET_SCREEN_WIDTH'
export const SET_MOBILE = 'SET_MOBILE'
export const SET_MOBILE_PHONE = 'SET_MOBILE_PHONE'

// persisted ux
export const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE'

// aggregate models
export const PUT_AGGREGATE_MODELS = 'PUT_AGGREGATE_MODELS'
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE'
export const SET_DATES = 'SET_DATES'

// election models
export const PUT_ELECTION_MODELS = 'PUT_ELECTION_MODELS'
export const CLEAR_MODELS = 'CLEAR_MODELS'

// landing models
export const PUT_LANDING_MODELS = 'PUT_LANDING_MODELS'
